import React from "react";
import { Layout } from "views/common/Layout";
import { siteConfig } from "config/site";
export const Terms = () => {
    return (
        <Layout>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
                <div className="mx-auto max-w-3xl">
                    <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                        Terms and Conditions
                    </h1>
                    <p className="mt-4 text-lg text-gray-600">
                        Last updated: {siteConfig.lastUpdated}
                    </p>

                    <div className="mt-8 space-y-8">
                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                1. Introduction
                            </h2>
                            <p className="mt-4 text-gray-600">
                                These terms and conditions (the "Terms") govern
                                your use of {siteConfig.name} (this website) and
                                the services we offer. By accessing or using our
                                website or its subsidiaries, you agree to be
                                bound by these Terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                2. Services
                            </h2>
                            <p className="mt-4 text-gray-600">
                                Our services are provided "as is" and without
                                any warranty. We reserve the right to modify or
                                discontinue our services at any time without
                                notice. Furthermore, {siteConfig.name} does not
                                make any representations concerning the accuracy
                                or reliability of the use of the materials on
                                its Website or otherwise relating to such
                                materials or any sites linked to this Website.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                3. User Account
                            </h2>
                            <div className="mt-4 space-y-4">
                                <p className="text-gray-600">
                                    In order to use our services, you must
                                    create an account with us. You are
                                    responsible for maintaining the
                                    confidentiality of your account and password
                                    and for restricting access to your computer.
                                    You agree to accept responsibility for all
                                    activities that occur under your account or
                                    password.
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                4. Receiving Emails
                            </h2>
                            <p className="mt-4 text-gray-600">
                                In order to provide you with our services, we
                                might send you occasional emails. You can
                                unsubscribe from these emails at any time unless
                                it is required to fulfill a service. We never
                                share emails with third parties.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                5. Content
                            </h2>
                            <div className="mt-4 space-y-4">
                                <p className="text-gray-600">
                                    Our website may contain links to third-party
                                    websites and resources. We have no control
                                    over the content of these websites and
                                    resources and are not responsible for their
                                    availability or accuracy. The inclusion of
                                    any link does not imply endorsement by us.
                                    You agree that we are not responsible or
                                    liable for any loss or damage of any sort
                                    incurred as the result of any such dealings.
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                6. Intellectual Property
                            </h2>
                            <p className="mt-4 text-gray-600">
                                The content on our website, including but not
                                limited to text, software, scripts, graphics,
                                photos, sounds, music, videos, interactive
                                features and the like ("Content") is protected
                                by copyright, trademark, patent, trade secret,
                                and other laws. You may not use our Content
                                without our prior written consent. You may not
                                modify, publish, transmit, participate in the
                                transfer or sale of, create derivative works
                                from, or in any way exploit, any of the Content,
                                in whole or in part.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                7. Indemnification
                            </h2>
                            <p className="mt-4 text-gray-600">
                                You agree to indemnify and hold us harmless from
                                any claim or demand, including reasonable
                                attorneys' fees, made by any third party due to
                                or arising out of your use of our website and
                                services, your violation of these Terms, or your
                                infringement of any intellectual property or
                                other right of any person or entity.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                8. Revisions and Errata
                            </h2>
                            <p className="mt-4 text-gray-600">
                                The materials appearing on {siteConfig.name}
                                Website may include technical, typographical, or
                                photographic errors. {siteConfig.name} will not
                                promise that any of the materials on this
                                Website are accurate, complete, or current.
                                {siteConfig.name} may change the materials
                                contained on its Website at any time without
                                notice. {siteConfig.name} does not make any
                                commitment to update the materials.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                9. Disclaimer
                            </h2>
                            <p className="mt-4 text-gray-600">
                                We make no representations or warranties of any
                                kind, express or implied, as to the operation of
                                our website or the information, content,
                                materials, or products included on our website.
                                To the full extent permissible by applicable
                                law, we disclaim all warranties, express or
                                implied, including but not limited to, implied
                                warranties of merchantability and fitness for a
                                particular purpose.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                10. Changes to these Terms
                            </h2>
                            <p className="mt-4 text-gray-600">
                                We may update these Terms from time to time. If
                                we make material changes, we will notify you by
                                email or through a prominent notice on our
                                website. Your continued use of our website and
                                services after such notice constitutes your
                                agreement to the new Terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-gray-900">
                                11. Contact Us
                            </h2>
                            <p className="mt-4 text-gray-600">
                                If you have any questions about these Terms,
                                please contact us at {siteConfig.contactEmail}.
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
